import React, { memo } from 'react';
import CountUp from 'react-countup';

const Metric = ({ value }: any) => {
  return <CountUp start={0} delay={0.5} duration={2} useEasing={false} end={value} />;
};

export default memo(Metric);
